var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50781 5C7.50781 5.14062 7.45312 5.25781 7.34375 5.35156C7.25 5.44531 7.13281 5.49219 6.99219 5.49219H2L0.0078125 7.50781V0.5C0.0078125 0.359375 0.0546875 0.242188 0.148438 0.148438C0.242188 0.0546875 0.359375 0.0078125 0.5 0.0078125H6.99219C7.13281 0.0078125 7.25 0.0546875 7.34375 0.148438C7.45312 0.242188 7.50781 0.359375 7.50781 0.5V5ZM9.5 2C9.64062 2 9.75781 2.04688 9.85156 2.14062C9.94531 2.23438 9.99219 2.35156 9.99219 2.49219V9.99219L8 8H2.49219C2.35156 8 2.23438 7.95312 2.14062 7.85938C2.04688 7.76562 2 7.64844 2 7.50781V6.5H8.49219V2H9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMsg);
export default __webpack_public_path__ + "static/media/ic_msg.f37cf03a2ed99a0fe717048a8dbad0b7.svg";
export { ForwardRef as ReactComponent };